import React from 'react';

import styles from './index.module.scss';

/**
 * 渲染加载状态 - 简单Loading转圈，零依赖
 */
const Loading = ({style}: {style?: React.CSSProperties}) => <div className={styles.loading} style={style} />;

export default Loading;
